import { Tooltip } from "@mui/material";
import { TFunction } from "i18next";
import { NeutralColor } from "node-library/dist/colors";
import {
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
} from "node-library/dist/portal";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export function getSpecificationIcon(
	specs: FrontendSampleSpecification,
	translation: TFunction<"translation", undefined>,
): React.ReactNode {
	let specIcon: React.ReactNode = <></>;
	if (specs.canDownload && specs.readingFileId) {
		specIcon = (
			<Tooltip
				PopperProps={{
					sx: {
						"& .MuiTooltip-tooltip": {
							backgroundColor: NeutralColor.NEUTRAL_GREY_950,
							padding: "12px 16px",
						},
					},
				}}
				title={`${translation("FileWithNotes")}`}
				arrow
			>
				<DescriptionOutlinedIcon sx={{ width: 24, height: 24 }} />
			</Tooltip>
		);
	} else if (specs.canDownload) {
		specIcon = (
			<Tooltip
				PopperProps={{
					sx: {
						"& .MuiTooltip-tooltip": {
							backgroundColor: NeutralColor.NEUTRAL_GREY_950,
							padding: "12px 16px",
						},
					},
				}}
				title={`${translation("File")}`}
				arrow
			>
				<UploadFileOutlinedIcon sx={{ width: 24, height: 24 }} />
			</Tooltip>
		);
	} else if (specs.readingFileId) {
		specIcon = (
			<Tooltip
				PopperProps={{
					sx: {
						"& .MuiTooltip-tooltip": {
							backgroundColor: NeutralColor.NEUTRAL_GREY_950,
							padding: "12px 16px",
						},
					},
				}}
				title={`${translation("Notes")}`}
				arrow
			>
				<FormatListBulletedOutlinedIcon sx={{ width: 24, height: 24 }} />
			</Tooltip>
		);
	}

	return specIcon;
}

export function getBreadcrumbsBySpecFile(
	specFile: FrontendSampleSpecification,
	specDirectories: Array<FrontendSampleSpecificationDirectory>,
): Array<FrontendSampleSpecificationDirectory> {
	const crumbs: Array<FrontendSampleSpecificationDirectory> = [];

	let tempFolder = specDirectories.find(
		(dir) => dir.directoryId === specFile?.parentDirectoryId,
	);

	while (tempFolder) {
		crumbs.unshift(tempFolder); // Add to the beginning of array
		// Find the parent of the current temp folder
		tempFolder = specDirectories.find(
			(dir) => dir.directoryId === tempFolder?.parentDirectoryId,
		);
	}
	return crumbs;
}
